import { takeLatest } from 'redux-saga';
import { apply, put } from 'redux-saga/effects';
import { api } from '../../common/api/api.js';
import { APP_INIT_DATA_FETCH, fetchInitialDataSuccess, fetchInitialDataFail } from './actions.jsx';
import { initFCH } from '../form.components/family.cancer.history/reducer.jsx';

export function* getInitialData(action) {
    const questionnaireService = api.service('questionnaire');
    const method = questionnaireService.get;
    try {
        const responseData = yield apply(questionnaireService, method, [action.token]);
        const responseActionObject = fetchInitialDataSuccess(responseData);
        //Need to init fch component separate from it react-component
        console.log('APP LOADED');
        yield put(responseActionObject);
        yield put(initFCH());
    } catch (error) {
        const errorActionObject = fetchInitialDataFail();
        yield put(errorActionObject);
        console.warn('Requires failed:');
        console.log(error);
        console.trace();
    }
}

export default function* appLoaderSaga() {
    yield* takeLatest(APP_INIT_DATA_FETCH, getInitialData);
}
